import { ChangeDetectionStrategy, Component, ElementRef, inject, output } from '@angular/core';
import { PageHeaderBackSwipeConfig, PageHeaderComponent } from '@app/components/page-header/page-header.component';

@Component({
  selector: 'app-more-league-bowling',
  templateUrl: './more-league-bowling.component.html',
  styleUrl: './more-league-bowling.component.scss',
  imports: [
    PageHeaderComponent,
  ],
  host: {
    class: 'page',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MoreLeagueBowlingComponent {

  private readonly elementRef = inject<ElementRef<HTMLElement>>(ElementRef);

  protected readonly backSwipeConfig: PageHeaderBackSwipeConfig = {
    element: this.elementRef.nativeElement,
  };

  public readonly back = output();

}
